import React from "react";
import { Skeleton } from "@mbank-design/design-system/components/Skeleton/Skeleton";
import { SkeletonVariant } from "@mbank-design/design-system/components/Skeleton/Skeleton.constants";

interface CalculatorSkeletonProps {
  activeTab: number;
}

const CalculatorSkeletonField = () => (
  <div className="calculator-skeleton__field">
    <Skeleton variant={SkeletonVariant.RECTANGULAR} height={14} width={140} />
    <Skeleton variant={SkeletonVariant.RECTANGULAR} height={36} width="100%" />
  </div>
);

const CalculatorSkeletonPackage = () => (
  <div className="calculator-skeleton__package">
    <Skeleton variant={SkeletonVariant.RECTANGULAR} height={20} width={20} />
    <Skeleton variant={SkeletonVariant.RECTANGULAR} height={16} width="70%" />
    <Skeleton variant={SkeletonVariant.RECTANGULAR} height={16} width={48} />
  </div>
);

export const CalculatorSkeleton = ({ activeTab }: CalculatorSkeletonProps) => {
  if (activeTab === 3) {
    return (
      <div className="calculator-skeleton calculator-skeleton--cash">
        <Skeleton variant={SkeletonVariant.RECTANGULAR} height={28} width="85%" />
        <div className="calculator-skeleton__price-row">
          <Skeleton variant={SkeletonVariant.RECTANGULAR} height={14} width={120} />
          <Skeleton variant={SkeletonVariant.RECTANGULAR} height={20} width={80} />
        </div>
        <div className="calculator-skeleton__buttons">
          <Skeleton variant={SkeletonVariant.RECTANGULAR} height={44} width="100%" />
          <Skeleton variant={SkeletonVariant.RECTANGULAR} height={44} width="100%" />
        </div>
      </div>
    );
  }

  return (
    <div className="calculator-skeleton">
      <CalculatorSkeletonField />
      <CalculatorSkeletonField />
      <CalculatorSkeletonField />
      <div className="calculator-skeleton__price-row">
        <Skeleton variant={SkeletonVariant.RECTANGULAR} height={14} width={130} />
        <Skeleton variant={SkeletonVariant.RECTANGULAR} height={20} width={90} />
      </div>
      <div className="calculator-skeleton__packages">
        <CalculatorSkeletonPackage />
        <CalculatorSkeletonPackage />
        <CalculatorSkeletonPackage />
      </div>
    </div>
  );
};

export const CalculatorBottomSkeleton = () => (
  <div className="calculator-skeleton__bottom">
    <div className="calculator-skeleton__price-row">
      <Skeleton variant={SkeletonVariant.RECTANGULAR} height={14} width={110} />
      <Skeleton variant={SkeletonVariant.RECTANGULAR} height={32} width={100} />
    </div>
    <div className="calculator-skeleton__buttons">
      <Skeleton variant={SkeletonVariant.RECTANGULAR} height={44} width="48%" />
      <Skeleton variant={SkeletonVariant.RECTANGULAR} height={44} width="48%" />
    </div>
  </div>
);
